export interface HomeSlideImageProps {
  id: string;
  url: string;
  fileName: string;
  altText?: string | null;
  mimeType: string;
  size: number;
}

export interface HomeSlideProps {
  id: string;
  title: string;
  description?: string | null;
  buttonTextPrimary?: string | null;
  buttonTextSecondary?: string | null;
  buttonUrlPrimary?: string | null;
  buttonUrlSecondary?: string | null;
  imageId: string;
  displayOrder: number;
  isActive: boolean;
  createdAt?: string;
  updatedAt?: string;
  image?: HomeSlideImageProps | null;
}

export class HomeSlideEntity {
  constructor(private readonly props: HomeSlideProps) {
    if (!props.id) throw new Error('El ID del slide es obligatorio.');
    if (!props.title) throw new Error('El título del slide es obligatorio.');
    if (!props.imageId && !props.image?.url) {
      throw new Error('La imagen del slide es obligatoria.');
    }
  }

  get id(): string {
    return this.props.id;
  }

  get title(): string {
    return this.props.title;
  }

  get description(): string | undefined {
    return this.props.description || undefined;
  }

  get buttonTextPrimary(): string | undefined {
    return this.props.buttonTextPrimary || undefined;
  }

  get buttonTextSecondary(): string | undefined {
    return this.props.buttonTextSecondary || undefined;
  }

  get buttonUrlPrimary(): string | undefined {
    return this.props.buttonUrlPrimary || undefined;
  }

  get buttonUrlSecondary(): string | undefined {
    return this.props.buttonUrlSecondary || undefined;
  }

  get imageId(): string {
    return this.props.imageId;
  }

  get displayOrder(): number {
    return this.props.displayOrder;
  }

  get isActive(): boolean {
    return this.props.isActive;
  }

  get createdAt(): string | undefined {
    return this.props.createdAt;
  }

  get updatedAt(): string | undefined {
    return this.props.updatedAt;
  }

  get image(): HomeSlideImageProps | null {
    return this.props.image ?? null;
  }

  get imageUrl(): string {
    return this.props.image?.url || '';
  }

  toggleActive(): HomeSlideEntity {
    return new HomeSlideEntity({
      ...this.props,
      isActive: !this.props.isActive,
    });
  }

  toJSON(): HomeSlideProps {
    return { ...this.props };
  }
}
